import { addDays, getMonth, getYear, startOfMonth, startOfWeek, subDays } from 'date-fns';
import memoize from 'lodash/memoize';

const rows = [...Array(6).keys()];
const cols = [...Array(7).keys()];

interface CalendarGenerator {
  year: number;
  month: number;
}

/**
 * @see         https://gist.github.com/miljan-aleksic/bd70452a3f0cd6a11545db9f6ab57df6
 * @description Returns a two-dimensional array with calendar represented dates
 */
function calendarGeneratorRaw(
  { year, month }: CalendarGenerator = {
    year: getYear(new Date()),
    month: getMonth(new Date()),
  },
  addPreviousWeek = true,
) {
  const matrix: Date[][] = [];
  const date = new Date(year, month);
  let curDate = startOfWeek(date);

  if (addPreviousWeek && curDate.getDate() === startOfMonth(curDate).getDate()) {
    // Go back a week if it starts on sunday, so we have a row of
    // previous month's
    curDate = subDays(curDate, 7);
  }

  rows.forEach(() => {
    const week: Date[] = [];

    cols.forEach(() => {
      week.push(curDate);
      curDate = addDays(curDate, 1);
    });

    matrix.push(week);
  });

  return matrix;
}

const calendarGenerator = memoize(calendarGeneratorRaw, (props?: CalendarGenerator, addPreviousWeek?: boolean) => {
  return `${props?.month}${props?.year}|${!!addPreviousWeek}`;
});

export { calendarGenerator };
